<template>
  <div class="new content-wrapper">
    <h1>Create New Content</h1>
    <Content :content="content"></Content>

    <button class="button" @click="create">Save</button>
  </div>
</template>

<script>
import firebase from 'firebase'
import Content from '@/components/content'
import { mapActions } from 'vuex'

export default {
  name: 'new',
  components: {
    Content,
  },
  data() {
    return {
      content: {
        status: 'Draft',
        type: '',
        htmlTitle: '',
        htmlMetaDescription: '',
        title: '',
        content: '',
        keyword: '',
        site: { id: '', name: '' },
        language: { id: '', name: '' },
        brand: { id: '', name: '' },
        summary: '',
        bonusReview: '',
        gameSelectionReview: '',
        pros: ['', '', ''],
        cons: ['', ''],
        faq: {
          title: '',
          questions: [{ question: '', answer: '' }],
        },
        howTo: {
          headline: '',
          description: '',
          time: '00:00',
          tools: [{ item: '' }],
          supplies: [{ item: '' }],
          steps: [{ headline: '', name: '', description: '' }],
        },
        prosConsShortcode: {
          headline: '',
          description: '',
          pros: [{ item: '' }],
          cons: [{ item: '' }],
        },
      },
    }
  },
  mounted() {
    this.updateContentType()
  },
  watch: {
    '$route.params.type': function() {
      this.updateContentType()
    },
  },
  methods: {
    ...mapActions(['createContent']),

    async create() {
      const doc = await this.createContent({ collection: 'content', newDocument: this.content }).catch(err => {
        this.$notify({
          text: 'Failed to create content',
          type: 'error',
        })
      })
      this.$notify({
        text: 'Successfully created content',
        type: 'success',
      })
      this.$router.push({ name: 'contentId', params: { id: doc.id } })
    },
    updateContentType() {
      if (this.$route.params.type == 'review') {
        this.content.type = 'Review'
      } else if (this.$route.params.type == 'seo') {
        this.content.type = 'SEO'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';
</style>
